import { render, staticRenderFns } from "./rmInpe.vue?vue&type=template&id=f8ccffa8"
import script from "./rmInpe.vue?vue&type=script&lang=js"
export * from "./rmInpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports